import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { buildRoutePath, routes } from '../../../constants/routes'
import Modal from '../../utils/modal'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const mapStateToProps = (state) => {
    return {
        keyIssueCategories: state.keyIssueCategories
    }
}


const ResourceTile = ({ resource, onHandleFilterClick, keyIssueCategories }) => {
    const { resource_type, title, source_title, key_issues, source_link } = resource
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)

    let keyIssues = key_issues.map((k, index) => {
        let res = keyIssueCategories.find((cat) => cat.name === k)
        if (onHandleFilterClick === undefined) {
            return <span key={index} className={`tag ${res.slug}`} onClick={() => handleTagClick(res.name)}>{k}</span>
        }
        return <span key={index} className={`tag ${res.slug}`} onClick={() => onHandleFilterClick(res.name)}>{k}</span>
    })

    const handleTagClick = (tag) => {
        let urlParams = new URLSearchParams({ category: tag }).toString()
        const route = buildRoutePath(routes.resourcesIndex.path) + '?' + urlParams
        navigate(route)
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }, 100)
    }

    const handleTitleClick = () => {
        setOpen(true)
    }

    const closeAction = () => {
        setOpen(false)
    }

    let credit = source_title ? <span className="source">({source_title})</span> : null

    return (
        <div className="resource-tile">
            <div className="content">
                <span className="label-header">{resource_type}</span>
                { source_link.error ?
                    (
                        <>
                            <p onClick={handleTitleClick}>{title}</p>
                            {open && <Modal closeAction={closeAction}>
                                <p style={{ textDecoration: 'none', cursor: 'default' }}>
                                    <MarkdownWrapper content={source_link.error} />
                                </p>
                            </Modal>}
                        </>
                    ) :
                    <p><a href={`${source_link.uri}`} target="_blank" rel="noreferrer">{title}</a></p>}
                { credit}
            </div>
            <div className="tags">
                {keyIssues}
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(ResourceTile)
